import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import GeneralPolicyApi from '../axios/General/GeneralPolicyApi';

export const useGetGeneralPolicyCountry = () => {
   const { getGeneralPolicyCountry } = GeneralPolicyApi();
   const { data, isLoading, error, isPending } = useQuery({
      queryKey: ['getGeneralPolicyCountry'],
      queryFn: async () => {
         try {
            const response = await getGeneralPolicyCountry();
            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
               return response.data.listCountry;
            }
         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error('Error fetching country');
               }
            }
         }
      },
   });

   return { data, isLoading, error, isPending };
};

export const useGetGeneralPolicyUserRole = () => {
   const { getGeneralPolicyUserRole } = GeneralPolicyApi();
   const { data, isLoading, error, isPending } = useQuery({
      queryKey: ['getGeneralPolicyUserRole'],
      queryFn: async () => {
         try {
            const response = await getGeneralPolicyUserRole();
            if (response.data.message === 'Successful' || response.data.message === 'Thành công') {
               return response.data.listUserRole;
            }
         } catch (error) {
            if (error.response) {
               if (error.response.status !== 401) {
                  toast.error('Error fetching user role');
               }
            }
         }
      },
   });

   return { data, isLoading, error, isPending };
};
